import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectVenueAnalysisWidgetKeys: (state: State) => string[] = (
    state
) => selectComponentKeysByType(state, WidgetType.VENUE_ANALYSIS);

export const selectVenueAnalysisWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).venueAnalysis;

export const selectVenueAnalysisState = (state: State, widgetKey: string) =>
    selectVenueAnalysisWidgetsState(state)[widgetKey];
